import { fetchSlimDevices as fetchSlimDevicesApi } from 'common-js/api';
import {
  FETCH_SLIM_DEVICES,
  FETCH_SLIM_DEVICES_SUCCESS,
  FETCH_SLIM_DEVICES_ERROR,
} from '../actionTypes';

const fetchSlimDevices = (deviceIds: Array<DeviceId>, orgId?: OrgId) => async (dispatch) => {
  dispatch({ type: FETCH_SLIM_DEVICES });

  return fetchSlimDevicesApi(deviceIds, orgId)
    .then((resp) => {
      dispatch({
        type: FETCH_SLIM_DEVICES_SUCCESS,
        loadingKey: FETCH_SLIM_DEVICES,
        devices: resp.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_SLIM_DEVICES_ERROR,
        loadingKey: FETCH_SLIM_DEVICES,
        error,
      });
    });
};

export default fetchSlimDevices;
